module.exports = __webpack_public_path__ + "img/illustration-8-raw.722ef8ed.jpg";